/* CGAP visual polish. Adds .is-in to elements as they scroll into view,
   measures hazard icon strokes for the draw-on effect, and counts up
   proof bar numbers. Does nothing when reduced motion is requested. */
(function () {
  'use strict';
  window.cgapWowReady = true;
  var root = document.documentElement;
  if (!root.classList.contains('cgap-anim') || !('IntersectionObserver' in window)) {
    root.classList.remove('cgap-anim');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      io.unobserve(el);
      if (el.classList.contains('product-card-wrapper')) {
        el.classList.add('cgap-shine-once');
        return;
      }
      el.classList.add('is-in');
      if (el.classList.contains('cgap-proof')) countUp(el);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

  function prepHazardIcons(scope) {
    scope.querySelectorAll('.hz').forEach(function (hz) {
      if (hz.dataset.cgapPrepped) return;
      hz.dataset.cgapPrepped = '1';
      hz.querySelectorAll('.hz-grid > a').forEach(function (a, i) {
        a.style.setProperty('--i', i);
        a.querySelectorAll('path, circle, rect, ellipse').forEach(function (s) {
          var len = 200;
          try { len = Math.ceil(s.getTotalLength()) + 2; } catch (err) {}
          s.style.setProperty('--len', len);
        });
      });
      io.observe(hz);
    });
  }

  function countUp(bar) {
    bar.querySelectorAll('[data-count]').forEach(function (el) {
      var target = parseFloat(el.dataset.count);
      if (isNaN(target)) return;
      var prefix = el.dataset.prefix || '';
      var suffix = el.dataset.suffix || '';
      var start = null;
      var dur = 1400;
      function tick(t) {
        if (start === null) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + Math.round(target * eased).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      el.textContent = prefix + '0' + suffix;
      requestAnimationFrame(tick);
    });
  }

  function init(scope) {
    scope = scope || document;
    prepHazardIcons(scope);
    scope.querySelectorAll('[data-cgap-reveal], .cgap-proof').forEach(function (el) {
      if (!el.classList.contains('is-in')) io.observe(el);
    });
    scope.querySelectorAll('.product-card-wrapper').forEach(function (el) {
      if (!el.classList.contains('cgap-shine-once')) io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Product cards added later (slider pages, filtering, infinite scroll) */
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; init(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
